import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { NumberBetweenFilterField } from "@ryde/controls";
import { usePageContext } from "@ryde/redux";
import { getGridLabelKey } from "@ryde/shared";

import { IFilterByIdsReportProps } from "./filters-by-ids.report.models";
import { useTableFiltersActionsReports } from "./use-table-filters-actions-reports";

/**
 * Reports wiring for the min/max range filter field. The stored [min, max] pair is decoded into a
 * criteria.where $between descriptor at request time (buildReportWhereDescriptor in use-report-actions).
 */
export const FilterNumberBetweenReport = ({
  templateKey,
  initialCheckedValues,
}: IFilterByIdsReportProps): ReactElement => {
  const { t } = useTranslation();
  const { entity } = usePageContext();
  const { setValuesToFilter, handleRemoveFilter } =
    useTableFiltersActionsReports();

  const onApply = (bounds: [number, number] | undefined): void => {
    setValuesToFilter(templateKey, bounds ?? []);
  };

  const onRemove = (): void => {
    handleRemoveFilter(templateKey);
  };

  return (
    <NumberBetweenFilterField
      fieldId={`report-filter-number-between-${templateKey}`}
      label={t(getGridLabelKey(entity, templateKey))}
      value={initialCheckedValues}
      onApply={onApply}
      onRemove={onRemove}
    />
  );
};
